var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F06A6A",
    d: "M8 2.1c-1.7397 0 -3.15 1.4103 -3.15 3.15S6.2603 8.4 8 8.4s3.15 -1.4103 3.15 -3.15S9.7397 2.1 8 2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F06A6A",
    d: "M4.05 9.1c-1.7397 0 -3.15 1.4103 -3.15 3.15 0 1.7397 1.4103 3.15 3.15 3.15s3.15 -1.4103 3.15 -3.15c0 -1.7397 -1.4103 -3.15 -3.15 -3.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F06A6A",
    d: "M11.95 9.1c-1.7397 0 -3.15 1.4103 -3.15 3.15 0 1.7397 1.4103 3.15 3.15 3.15 1.7397 0 3.15 -1.4103 3.15 -3.15 0 -1.7397 -1.4103 -3.15 -3.15 -3.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsanaLogo);
export default __webpack_public_path__ + "static/media/asana-logo.acccc16fed886b0e3549c0aa7c9d639b.svg";
export { ForwardRef as ReactComponent };